<!--页面代码从这里开始拷贝-->
<template>
    <div>
      <table-compnent
        :records="tableData"
        @resetHandler="reset"
        @searchHandler="doSearch"
        @queryByIdHandler="queryById"
        @deleteByIdHandler="deleteById"
        @batchDeleteHandler="batchDelete"
        @addHandler="saveSysDepository"
      >
        <template v-slot:search>
          <el-form-item label="名称:">
            <el-input
              v-model="search.name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="是否推荐:">
            <el-select v-model="search.isRecommand" placeholder="请选择">
              <el-option
                v-for="item in recommands"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型:">
            <el-select v-model="search.type" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
          </el-form-item>
          <el-form-item label="所属区域:">
            <el-select v-model="search.area" placeholder="请选择">
                  <el-option
                    v-for="item in areas"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
          </el-form-item>
        </template>
        <template v-slot:moreOpt>
          <el-button type="primary" @click="checkMyself">一键在线应用自查</el-button>
        </template>
        <template v-slot:content>
          <el-table-column prop="id" label="id"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="url" label="链接地址" style="width:300px;"></el-table-column>
          <el-table-column prop="type" label="类型"></el-table-column>
          <el-table-column prop="area" label="所属区域"></el-table-column>
          <el-table-column prop="isRecommand" label="是否推荐使用"></el-table-column>
          <el-table-column prop="createTime" label="最近创建时间"></el-table-column>
          <el-table-column prop="updateTime" label="最近更新时间"></el-table-column>
        </template>

        <template v-slot:operation="row">
          <el-button type="text" size="small" @click="checkServer(row.record)">检查</el-button>
       </template> 
      </table-compnent>  
    </div>
  </template>
  
  <script>
  import TableCompnent from "@/components/table/TablesComponents";
  import SysDepositoryApi from '@/api/SysDepositoryApi';
  import { navTo,queryParam } from "@/utils/NavigatorUtils";
  export default {
    name: "SysDepositoryList",
    props: {
      msg: String,
    },
    components: {
      TableCompnent
    },
    data() {
      return {
        tableData: {},
        search: {
          name: "",
          type:"",
          isRecommand:""
        },
        page:{},
        options:[
        {
          value:"software",
          label:"软件镜像"
        },
        {
          value:"frontend",
          label:"前端资源"
        },
        {
          value:"monitor",
          label:"监控接口资源"
        }
      ],
      recommands:[
        {
          value:1,
          label:"推荐"
        },
        {
          value:0,
          label:"不推荐"
        }
      ],
      areas:[
        {
          value:"",
          label:"不限"
        },
        {
          value:"chengdu",
          label:"成都"
        },
        {
          value:"xian",
          label:"西安"
        },
        {
          value:"urumqi",
          label:"乌鲁木齐"
        }
      ]
      };
    },
    methods: {
      reset() {
        this.search = {};
      },
      doSearch(params) {
        this.page = params;
        this.search.pageSize = this.page.pageSize
        this.search.pageNum = this.page.pageNum
        SysDepositoryApi.search(this.search).then((resp)=>{
          if(resp.state=="OK"){
            this.tableData = resp.data
          }
        })
      },
      saveSysDepository(){
          navTo(this,"/saveSysDepository");
      },
      queryById(id){
        SysDepositoryApi.querySysDepositoryById(id).then((resp)=>{
          if(resp.state=="OK"){
            queryParam(this,"saveSysDepository",resp.data);
          }
        })
      },
      deleteById(id){
        SysDepositoryApi.deleteSysDepository(id).then((resp)=>{
          if(resp.state=="OK"){
            this.doSearch(this.page)
          }else{
            this.$errorMsg(resp.msg)
          }
        })
      },
      batchDelete(params){
        SysDepositoryApi.batchDeleteSysDepository(params).then((resp)=>{
          if(resp.state=="OK"){
            this.$successMsg(resp.msg)
            this.doSearch(this.page)
          }else{
            this.$errorMsg(resp.msg)
          }
        })
      },
      checkMyself(){
        SysDepositoryApi.checkMyself({}).then((resp)=>{
          if(resp.state=="OK"){
             this.$successMsg(resp.msg)
          }else{
            this.$errorMsg(resp.msg)
          }
        })
      },
      checkServer(obj){
        if(obj.type!="monitor"){
          this.$errorMsg("非监控接口资源，不支持当前操作")
        }else{
          SysDepositoryApi.checkMyselfById({id:obj.id}).then((resp)=>{
          if(resp.state=="OK"){
             this.$successMsg(resp.msg)
          }else{
            this.$errorMsg(resp.msg)
          }
        })
        }
      }
    },
  };
  </script>
  <!--页面代码从这里结束拷贝-->